import { AkaStudentProduct } from "Store/interfaces/products/checkout/riskProducts/AkaStudentProduct";
import { ProductDetail } from "../../interface";

export const akaStudentDetailsList = (
  product: AkaStudentProduct,
  types: any,
  lang: string,
): ProductDetail[] => [
  {
    name: "country",
    value: product.country,
    hidden: !product.country,
  },
  {
    name: "coverage",
    value: types.coverageGroup[product.coverageGroup][lang],
  },
];
